import { Controller } from "@hotwired/stimulus"

// "Zaznacz/Odznacz wszystkie" button for a group of checkboxes, with an
// optional "N zaznaczonych" counter.
export default class extends Controller {
  static targets = ["checkbox", "counter"]

  connect() {
    this.updateCounter()
  }

  // e.g. a row removed from the comparison table
  checkboxTargetDisconnected() {
    this.updateCounter()
  }

  toggle() {
    const check = !this.checkboxTargets[0]?.checked
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = check })
    this.updateCounter()
  }

  updateCounter() {
    if (!this.hasCounterTarget) return

    const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.counterTarget.textContent = count > 0 ? `${count} zaznaczonych` : " "
    this.counterTarget.style.visibility = count > 0 ? "visible" : "hidden"
  }
}
